(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3428],{

/***/ 66452:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tiles/[...category]",
      function () {
        return __webpack_require__(66970);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_loaders_kit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37169);
/* harmony import */ var react_loaders_kit__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_loaders_kit__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_typed__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27788);
/* harmony import */ var react_typed__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_typed__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(6212);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(35005);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83346);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _api_services_js_catalouge__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27719);
/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46737);
/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(sweetalert__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _api_services_js_others__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63372);
/* harmony import */ var _src_components_loader__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62077);
/* harmony import */ var _src_productCard__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(93115);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31955);
/* harmony import */ var react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(4492);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(6154);
/* harmony import */ var _src_UnbxdProductCard__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64642);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react_confetti__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(40725);
/* harmony import */ var react_confetti__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(react_confetti__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _fireworks_js_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(66706);
/* harmony import */ var _videoSchema__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(94793);
/* harmony import */ var _videoSchema__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_videoSchema__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var react_use_lib_useWindowSize__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(62964);
/* harmony import */ var _attributes_json__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(25690);




//import Modal from "react-modal";

















// import generateVideoSchema from '../../utils/videoSchema.js'
// const { JSDOM } = require('jsdom');





const Category = (data)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    let router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    const [UnbxdPdts, setUnbxdPdts] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(data.UnbxdResponse.products);
    const [ProdBySalesDate, setProdBySalesDate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(data.ProdBySalesDate);
    const [PageSalesSize, setPageSalesSize] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(15);
    const [fitterrss2, setfitterrss2] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(data.fitterrss2);
    const [dataSet, setDataSet] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(data.data.products);
    const [filterData, setFilterData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(data.data.products.aggregations);
    const [selectedFilterData, setSelectedFilterData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [filterTypeDataSet, setFilterTypeDataSet] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [isParamChange, setIsParamChange] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [relatedBlogData, setRelatedBlogData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [sortValue, setSortValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(data.data.products.sort_fields.default);
    const [selectedCode, setSelectedCode] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [selectedFilters, setSelectedFilters] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [isFilterselected, setIsFilterselected] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [openFilterFlag, setOpenFilterFlag] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [isAmbience, setIsAmbience] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [loading2, setLoading2] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [getInTouch, setGetInTouch] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [filteractive, setFilterActive] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [mobileFilterOpen, setmobileFilterOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [StatePlant, setStatePlant] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        "Andaman and Nico.In.": [
            "01",
            "Hoskote",
            "Dora",
            "West Zone"
        ],
        "Andhra Pradesh": [
            "02",
            "Hoskote",
            "Sikandrabad",
            "West Zone"
        ],
        Assam: [
            "03",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        "Arunachal Pradesh": [
            "41",
            "Sikandrabad",
            "Dora",
            "West Zone"
        ],
        Bihar: [
            "04",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        Bhutan: [
            "38",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        Chandigarh: [
            "47",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        Chattisgarh: [
            "05",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        "Dadra and Nagar Hav.": [
            "55",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        Delhi: [
            "06",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        Goa: [
            "07",
            "Hoskote",
            "Dora",
            "West Zone"
        ],
        Gujarat: [
            "08",
            "Hoskote",
            "Dora",
            "West Zone"
        ],
        Haryana: [
            "09",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        "Himachal Pradesh": [
            "10",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        "Jammu and Kashmir": [
            "11",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        Jharkhand: [
            "12",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        Karnataka: [
            "13",
            "Hoskote",
            "Dora",
            "West Zone"
        ],
        Kerala: [
            "14",
            "Hoskote",
            "Dora",
            "West Zone"
        ],
        "Madhya Pradesh": [
            "15",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        Mahe: [
            "78",
            "Sikandrabad",
            "West Zone"
        ],
        Manipur: [
            "45",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        Meghalaya: [
            "17",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        Mizoram: [
            "42",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        Myanmar: [
            "59",
            "Sikandrabad",
            "West Zone"
        ],
        Nagaland: [
            "18",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        Nepal: [
            "19",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        Maharashtra: [
            "16",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        Puducherry: [
            "21",
            "Hoskote",
            "West Zone"
        ],
        Odisha: [
            "20",
            "Hoskote",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        Punjab: [
            "22",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        Rajasthan: [
            "23",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        "Tamil Nadu": [
            "25",
            "Hoskote",
            "Dora",
            "West Zone"
        ],
        Telangana: [
            "64",
            "Hoskote",
            "Dora",
            "West Zone"
        ],
        Tripura: [
            "26",
            "Hoskote",
            "Dora",
            "West Zone"
        ],
        "Uttar Pradesh": [
            "27",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        Uttarakhand: [
            "28",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ],
        "West Bengal": [
            "29",
            "Dora",
            "Sikandrabad",
            "West Zone"
        ]
    });
    const [touch, setTouch] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        name: "",
        number: "",
        pincode: js_cookie__WEBPACK_IMPORTED_MODULE_13__/* ["default"].get */ .Z.get("pincode"),
        error: "",
        loading: false
    });
    const [pageLayoutClass, setPageLayoutlass] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("product-listing-Three obl-pro-list-row");
    const [filterSet, setFilterSet] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        filter: {
            category_id: {
                in: [
                    data.value
                ]
            }
        },
        sort: {
            recommended: "ASC"
        },
        pageSize: 15,
        currentPage: 1
    });
    const [modalIsOpen, setModalIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [pincode, setPinCode] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(undefined);
    const [isExpanded, setIsExpanded] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [stores, setStores] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [visibleCount, setVisibleCount] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(6);
    const [stickyTop, setStickyTop] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [pinFromCityPage, setPinFromCityPage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(data.PinFromCityPage);
    const [cityName, setCityName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [throwConfetti, setThrowConfetti] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { width , height  } = (0,react_use_lib_useWindowSize__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)();
    const [firstLoading, setFirstLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [defaultFacets, setDefaultFacets] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(data === null || data === void 0 ? void 0 : (ref = data.facetsUnbxd) === null || ref === void 0 ? void 0 : (ref1 = ref.text) === null || ref1 === void 0 ? void 0 : ref1.list);
    const [selectedFilterFromUnbxd, setSelectedFilterFromUnbxd] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [noOfFilteredPdtFromUnbxd, setNoOfFilteredPdtFromUnbxd] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const totalProducts = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return (selectedFilterFromUnbxd === null || selectedFilterFromUnbxd === void 0 ? void 0 : selectedFilterFromUnbxd.length) > 1 ? noOfFilteredPdtFromUnbxd : data.UnbxdResponse.numberOfProducts;
    }, [
        selectedFilterFromUnbxd,
        noOfFilteredPdtFromUnbxd,
        data.UnbxdResponse.numberOfProducts
    ]);
    const [totalPdtsFromUnbxd, setTotalPdtsFromUnbxd] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(data.UnbxdResponse.numberOfProducts);
    let pageSizeUnbxd = data === null || data === void 0 ? void 0 : (ref2 = data.UnbxdResponse) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.products) === null || ref3 === void 0 ? void 0 : ref3.length;
    const filterMapArr = [
        {
            tileType_uFilter: "tile_type",
            tileSize_uFilter: "tile_size",
            tilesFinish_uFilter: "tiles_finish",
            colors_uFilter: "colors",
            tileCollections_uFilter: "tile_collections",
            tileFactoryProduction_uFilter: "tile_factory_production",
            tileDesign_uFilter: "tile_design",
            tileCategory_uFilter: "tile_category",
            tileArea_uFilter: "tile_area"
        }
    ];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (data.PinFromCityPage) {
            js_cookie__WEBPACK_IMPORTED_MODULE_13__/* ["default"].set */ .Z.set("skipLocation", true, {
                expires: 7,
                secure: true,
                sameSite: "Strict"
            });
            getStores();
        } else {
            js_cookie__WEBPACK_IMPORTED_MODULE_13__/* ["default"].remove */ .Z.remove("skipLocation");
        }
    }, [
        pinFromCityPage
    ]);
    const getStores = async ()=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        let apiresult = await axios__WEBPACK_IMPORTED_MODULE_21__/* ["default"].get */ .Z.get("https://proxy.orientbell.com/storelocator/index/index?pincode=".concat(pinFromCityPage, "&req_from_city_page='true'&_=").concat(Date.now()));
        let cityNameInCapital = ((ref3 = (ref2 = (ref1 = data === null || data === void 0 ? void 0 : (ref = data.categoryValue) === null || ref === void 0 ? void 0 : ref.split("/")) === null || ref1 === void 0 ? void 0 : ref1.slice(-1)[0] // Get the last element from the split array
        ) === null || ref2 === void 0 ? void 0 : ref2.charAt(0)) === null || ref3 === void 0 ? void 0 : ref3.toUpperCase()) + ((ref6 = (ref5 = data === null || data === void 0 ? void 0 : (ref4 = data.categoryValue) === null || ref4 === void 0 ? void 0 : ref4.split("/")) === null || ref5 === void 0 ? void 0 : ref5.slice(-1)[0]) === null || ref6 === void 0 ? void 0 : ref6.slice(1)); // Get the rest of the string after the first character
        setCityName(cityNameInCapital);
        let cc = data === null || data === void 0 ? void 0 : (ref7 = data.categoryValue) === null || ref7 === void 0 ? void 0 : ref7.split("/")[((ref9 = data === null || data === void 0 ? void 0 : (ref8 = data.categoryValue) === null || ref8 === void 0 ? void 0 : ref8.split("/")) === null || ref9 === void 0 ? void 0 : ref9.length) - 1];
        cc.toLowerCase();
        // setStores(apiresult.data)
        let res = apiresult.data.filter((obj, idx)=>{
            let cityInLC = obj.city.toLowerCase();
            return cityInLC == cc;
        });
        if (res.length === 0) {
            // No city match, so filter by state
            res = apiresult.data.filter((obj)=>{
                let stateInLC = obj.state.toLowerCase();
                return stateInLC === cc;
            });
        }
        setStores(res);
    };
    const showMoreStores = ()=>{
        setVisibleCount(stores.length);
    };
    const showLessStores = ()=>{
        setVisibleCount(6);
    };
    const toggleExpand = ()=>{
        setIsExpanded(!isExpanded);
    };
    // Function to truncate the HTML content to a certain length
    const wordLimit = 30; // Set your word limit here
    const shortDescription = (dataSet === null || dataSet === void 0 ? void 0 : (ref4 = dataSet.currentcategory) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.description) === null || ref5 === void 0 ? void 0 : ref5.split(" ").slice(0, wordLimit).join(" ")) + ((dataSet === null || dataSet === void 0 ? void 0 : (ref6 = dataSet.currentcategory) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.description) === null || ref7 === void 0 ? void 0 : ref7.split(" ").length) > wordLimit ? "..." : "");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        window.UnbxdAnalyticsConf = window.UnbxdAnalyticsConf || {};
        window.UnbxdAnalyticsConf["page"] = router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("?")[0];
        window.UnbxdAnalyticsConf["page_type"] = "BOOLEAN";
        setLoading(false);
        setLoading(false);
        setDataSet(data.data.products);
        setFilterData(data.data.products.aggregations);
        setProdBySalesDate(data.ProdBySalesDate);
        setfitterrss2(data.fitterrss2);
    }, [
        router
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        jquery__WEBPACK_IMPORTED_MODULE_9___default()(".toggle").click(function(e) {
            e.preventDefault();
            var $this = jquery__WEBPACK_IMPORTED_MODULE_9___default()(this);
            if ($this.next().hasClass("show")) {
                $this.next().removeClass("show");
                $this.next().slideUp(350);
            } else {
                $this.parent().parent().find("li .inner").removeClass("show");
                $this.parent().parent().find("li .inner").slideUp(350);
                $this.next().toggleClass("show");
            }
        });
        var requestOptions = {
            method: "GET"
        };
        const tempFilterTypeArray = [];
        let excludeValues = [
            "wall-tiles",
            "floor-tiles"
        ];
        filterData.forEach((obj)=>{
            if (obj.attribute_code == "tile_category" && !excludeValues.includes(data.categoryValue)) {
                tempFilterTypeArray.push("Floor");
            } else if (obj.attribute_code !== "price" && obj.attribute_code !== "tile_category" && obj.attribute_code !== "istiles" && obj.attribute_code !== "plocation" && obj.attribute_code !== "category_id" && obj.attribute_code !== "recommended" && obj.attribute_code !== "popularity" && obj.attribute_code !== "available_region_bucket") {
                tempFilterTypeArray.push(obj.label);
            }
        });
        setFilterTypeDataSet(tempFilterTypeArray);
        onFilterOnClickButton(tempFilterTypeArray[0]);
        const selectedFilterFromLocalStorage = localStorage.getItem("selectedFilter");
        const pin = js_cookie__WEBPACK_IMPORTED_MODULE_13__/* ["default"].get */ .Z.get("pincode");
        setPinCode(pin);
        fetch("".concat(_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/blog/wp-json/post/v2/category/term=").concat(data.categoryValue.split("/")[data.categoryValue.split("/").length - 1]), requestOptions).then((response)=>response.text()).then((result)=>{
            setRelatedBlogData(JSON.parse(result));
        }).catch((error)=>console.log("error", error));
        if (selectedFilterFromLocalStorage) {
        // const finalResult = JSON.parse(selectedFilterFromLocalStorage);
        // const selFilt = {
        //   key: finalResult.key,
        //   value: finalResult.value,
        //   code: finalResult.code,
        // };
        // selectedFilters.push(selFilt);
        // setSelectedFilters(selectedFilters);
        // setIsFilterselected(true);
        // setPinCode(pin);
        } else {
            // setPinCode(undefined);
            setTimeout(()=>{
            // if(!localStorage.getItem('pincodeSkip')){
            //   setModalIsOpen(true);
            // }
            }, 5000);
        }
    }, [
        router
    ]);
    let loadMoreSalesData = async (pin)=>{
        setLoading2(true);
        let respp = await axios__WEBPACK_IMPORTED_MODULE_21__/* ["default"].post */ .Z.post("https://proxy.orientbell.com/api/products?category=".concat(data.value, "&pincode=").concat(pin, "&size=").concat(PageSalesSize + 15), fitterrss2);
        setPageSalesSize(PageSalesSize + 15);
        setProdBySalesDate(respp.data);
        setLoading2(false);
    };
    const loadMoreSalesData2 = async ()=>{
        setLoading2(true);
        try {
            var ref;
            const pageSize = 25; // Batch size
            const currentCount = UnbxdPdts.length; // Current count of loaded products
            const response = await axios__WEBPACK_IMPORTED_MODULE_21__/* ["default"].get */ .Z.get("https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category?p-id=categoryPathId%3A%22".concat(encodeURIComponent((ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("?")[0]), "%22&facet.multiselect=true&spellcheck=true&pagetype=boolean&rows=").concat(pageSize, "&start=").concat(currentCount, "&version=V2&fallback=true&viewType=GRID&facet.version=V2"));
            const newProducts = response.data.response.products || [];
            if (newProducts.length > 0) {
                setUnbxdPdts((prevPdts)=>[
                        ...prevPdts,
                        ...newProducts
                    ]); // Append new products
            }
            setTotalPdtsFromUnbxd(response.data.response.numberOfProducts); // Update total product count
        } catch (error) {
            console.error("Error loading more products:", error);
        }
        setLoading2(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isParamChange) {
            jquery__WEBPACK_IMPORTED_MODULE_9___default()(".main-sidebar").removeClass("open-filter");
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            let filterrrr = filterSet.filter;
            if (data.regionData) {
                filterrrr = {
                    ...filterrrr,
                    plocation: {
                        in: [
                            data.regionData.value
                        ]
                    }
                };
            }
            var graphql = JSON.stringify({
                variables: {
                    filter: data.fitterrss,
                    sort: filterSet.sort,
                    pageSize: filterSet.pageSize,
                    currentPage: filterSet.currentPage
                },
                query: getProductQuery
            });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: graphql,
                redirect: "follow"
            };
            fetch("https://proxy.orientbell.com", requestOptions).then((response)=>response.text()).then((result)=>{
                const finalResult = JSON.parse(result);
                setDataSet(finalResult.data.products);
                setFilterData(finalResult.data.products.aggregations);
                const tempFilterTypeArray = [];
                let excludeValues = [
                    "wall-tiles",
                    "floor-tiles"
                ];
                finalResult.data.products.aggregations.forEach((obj)=>{
                    if (obj.attribute_code == "tile_category" && !excludeValues.includes(data.categoryValue)) {
                        tempFilterTypeArray.push("Floor");
                    } else if (obj.attribute_code !== "price" && obj.attribute_code !== "tile_category" && obj.attribute_code !== "istiles" && obj.attribute_code !== "plocation" && obj.attribute_code !== "category_id" && obj.attribute_code !== "recommended" && obj.attribute_code !== "popularity" && obj.attribute_code !== "available_region_bucket") {
                        tempFilterTypeArray.push(obj.label);
                    }
                });
                setFilterTypeDataSet(tempFilterTypeArray);
                setOpenFilterFlag(true);
                setIsParamChange(false);
                setLoading(false);
                setLoading2(false);
            }).catch((error)=>console.log("error", error));
        }
    }, [
        filterSet,
        isParamChange,
        data.appliedFilterFromUnbxd
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isFilterselected) {
            let createFilterDtoSet = {
                category_id: {
                    in: [
                        data.value
                    ]
                }
            };
            selectedFilters.forEach((obj)=>{
                if (obj.code in createFilterDtoSet) {
                    const arrayValue = createFilterDtoSet[obj.code].in;
                    if (!arrayValue.includes(obj.key)) {
                        arrayValue.push(obj.key);
                    }
                    createFilterDtoSet[obj.code].in = arrayValue;
                } else {
                    const newFilterSet = {
                        [obj.code]: {
                            in: [
                                obj.key
                            ]
                        }
                    };
                    createFilterDtoSet = {
                        ...createFilterDtoSet,
                        ...newFilterSet
                    };
                }
            });
            setFilterSet({
                ...filterSet,
                filter: createFilterDtoSet
            });
            setLoading(true);
            setIsParamChange(true);
            setIsFilterselected(false);
        }
    }, [
        selectedFilters,
        isFilterselected
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (openFilterFlag) {
            onFilterOnClickButton(filterTypeDataSet[0]);
            setOpenFilterFlag(false);
        }
    }, [
        filterData
    ]);
    const getProductQuery = "query Products ($filter: ProductAttributeFilterInput!, $sort: ProductAttributeSortInput!, $pageSize: Int!, $currentPage: Int!){\n      products(\n          filter: $filter,\n          sort: $sort,\n          pageSize: $pageSize,\n          currentPage: $currentPage\n      ) {\n      currentcategory{\n          name\n          description\n          dynamic_content\n          imageUrl\n          meta_keywords\n          meta_description\n          meta_title\n          schema\n          breadcrumbs{\n            category_id\n            category_name\n            category_level\n            category_url_key\n            category_url_path\n        }\n      }\n      appliedFilters{\n        label\n        value\n        attribute_code\n    }\n      aggregations(filter: { category: {includeDirectChildrenOnly: true}}) {\n          attribute_code\n          count\n          label\n          options {\n              label\n              value\n              count\n              swatch_data {\n                  type\n                  value\n              }\n          }\n      }\n      subcategories{\n          id\n          name\n          imageUrl\n      }\n      total_count\n      items {\n          id\n          name\n          sku\n          url_key\n          price_range {\n          minimum_price {\n              regular_price {\n              value\n              currency\n              }\n              final_price {\n              value\n              currency\n              }\n              discount {\n              amount_off\n              percent_off\n              }\n          }\n          maximum_price {\n              regular_price {\n              value\n              currency\n              }\n              final_price {\n              value\n              currency\n              }\n              discount {\n              amount_off\n              percent_off\n              }\n          }\n          }\n          extraVariables{\n            skd_stock\n            dora_stock\n            hoskote_stock\n            west_zone_stock\n              is_enabled\n              is_new\n              image_url\n              ambience_image_url\n              product_url\n              tile_size\n              sq_ft_price\n          }\n      }\n      total_count\n      sort_fields{\n          default\n          options {\n          value\n          label\n          }\n      }\n      }\n    }";
    const getPloaction = "query P_location($pincode: Int!){\n    p_location(pincode : $pincode){\n      pincode\n      attribute_name\n      state\n      value\n    }\n  }";
    const onFilterOnClickButton = (value)=>{
        const filterValuesArray = [];
        if (value == "Floor") {
            filterData.forEach((obj)=>{
                if (obj.label == "Tile Category") {
                    setSelectedCode(obj.attribute_code);
                    obj.options.forEach((val)=>{
                        const tempFilterDataSet = {
                            key: val.value,
                            value: val.label
                        };
                        if (router.query.category[router.query.category.length - 1] == "vitrified-tiles" && tempFilterDataSet.value !== "Walls" && tempFilterDataSet.key != tempFilterDataSet.value) {
                            filterValuesArray.push(tempFilterDataSet);
                        } else if (router.query.category[router.query.category.length - 1] != "vitrified-tiles" && tempFilterDataSet.key != tempFilterDataSet.value) {
                            filterValuesArray.push(tempFilterDataSet);
                        }
                    });
                }
            });
        } else {
            filterData.forEach((obj)=>{
                if (obj.label == value) {
                    setSelectedCode(obj.attribute_code);
                    obj.options.forEach((val)=>{
                        const tempFilterDataSet = {
                            key: val.value,
                            value: val.label
                        };
                        if (tempFilterDataSet.key != tempFilterDataSet.value) {
                            filterValuesArray.push(tempFilterDataSet);
                        }
                    });
                }
            });
        }
        setSelectedFilterData(filterValuesArray);
    };
    const handleSortChange = (e)=>{
        var ref, ref1;
        setSortValue((ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
        const newSort = {
            [(ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.value]: "ASC"
        };
        setFilterSet({
            ...filterSet,
            sort: newSort
        });
        setLoading(true);
        setIsParamChange(true);
    };
    const onFilterClick = (e, title)=>{
        setmobileFilterOpen(false);
        jquery__WEBPACK_IMPORTED_MODULE_9___default()(".main-sidebar").toggleClass("open-filter");
        setLoading(true);
        let queryObj = router.query;
        queryObj[selectedCode] = e;
        delete queryObj["category"];
        router.replace({
            pathname: "/".concat(data.categoryValue),
            query: queryObj
        });
        return;
        const selFilt = {
            key: e,
            value: title,
            code: selectedCode
        };
        selectedFilters.push(selFilt);
        setSelectedFilters(selectedFilters);
        setIsFilterselected(true);
    };
    const handleRemove = (input)=>{
        setLoading(true);
        let queryObj = router.query;
        if (queryObj[input.attribute_code].split(",").length == 1) {
            delete queryObj[input.attribute_code];
        } else {
            queryObj[input.attribute_code] = queryObj[input.attribute_code].split(",").filter((cc)=>cc != input.value).join(",");
        }
        delete queryObj["category"];
        router.replace({
            pathname: "/".concat(data.categoryValue),
            query: queryObj
        });
        return;
        let toRemoveFilter = selectedFilters;
        toRemoveFilter = toRemoveFilter.filter((item)=>item !== input);
        setSelectedFilters(toRemoveFilter);
        setIsFilterselected(true);
        if (input.code == "plocation") {
            localStorage.removeItem("selectedFilter");
            setPinCode("");
        }
    };
    const handleRemove2 = ()=>{
        setLoading(true);
        js_cookie__WEBPACK_IMPORTED_MODULE_13__/* ["default"].remove */ .Z.remove("pincode");
        localStorage.removeItem("pincode");
        js_cookie__WEBPACK_IMPORTED_MODULE_13__/* ["default"].set */ .Z.set("removelocation", true, {
            expires: 7,
            secure: true,
            sameSite: "Strict"
        });
        router.reload();
    };
    const removeAllFilters = ()=>{
        handleRemove2();
        router.replace({
            pathname: "/".concat(data.categoryValue)
        });
        return;
        setFilterSet({
            ...filterSet,
            filter: {
                category_id: {
                    in: [
                        data.value
                    ]
                }
            }
        });
        setLoading(true);
        setIsParamChange(true);
        setSelectedFilters([]);
        localStorage.removeItem("selectedFilter");
        setPinCode("");
    };
    const handleAmbience = (e)=>{
        setIsAmbience(e.target.checked);
    };
    const LoadFunction = ()=>{
        const loaderProps = {
            loading: true,
            size: 275,
            duration: 2,
            colors: [
                "#99fffe",
                "#f42e00",
                "#042549"
            ]
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "loader",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loaders_kit__WEBPACK_IMPORTED_MODULE_2__.GooeyCircleLoader, {
                    ...loaderProps
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_typed__WEBPACK_IMPORTED_MODULE_3___default()), {
                    className: "loader-text",
                    strings: [
                        "Loading..."
                    ],
                    typeSpeed: 60,
                    backSpeed: 0
                })
            ]
        });
    };
    const handleLayOutclass = (type)=>{
        if (type == "one") {
            setPageLayoutlass("product-listing-Three obl-pro-list-row");
        } else if (type == "two") {
            setPageLayoutlass("product-listing-Two obl-pro-list-row");
        } else if (type == "three") {
            setPageLayoutlass("product-listing-One obl-pro-list-row");
        }
    };
    const handlePinCodeChange = (e)=>{
        setPinCode(e.target.value);
    };
    const handlePinCodeChangeInput = (e)=>{
        setPinCode(e.target.value);
        const pincode = e.target.value * 1;
        if (e.target.value.length == 6) {
            setStickyTop(true);
            if (!localStorage.getItem("pincode")) {
                setFirstLoading(true);
            }
            setLoading(true);
            (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_10__/* .savePincode */ .y1)({
                pincodedetails: pincode
            });
            js_cookie__WEBPACK_IMPORTED_MODULE_13__/* ["default"].set */ .Z.set("pincode", pincode, {
                expires: 7,
                secure: true,
                sameSite: "Strict"
            });
            localStorage.setItem("pincode", pincode);
            localStorage.setItem("pincodeSkip", true);
            router.reload();
            return;
            setLoading(true);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var graphql = JSON.stringify({
                query: getPloaction,
                variables: {
                    pincode
                }
            });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: graphql,
                redirect: "follow"
            };
            fetch("https://proxy.orientbell.com", requestOptions).then((response)=>response.text()).then((result)=>{
                let filterArray = selectedFilters;
                if (selectedFilters.length > 0) {
                    localStorage.removeItem("selectedFilter");
                    localStorage.removeItem("pincode");
                    filterArray = filterArray.filter((item)=>item.code !== "plocation");
                }
                const finalResult = JSON.parse(result);
                const selFilt = {
                    key: finalResult.data.p_location.value,
                    value: finalResult.data.p_location.state,
                    code: finalResult.data.p_location.attribute_name
                };
                filterArray.push(selFilt);
                setSelectedFilters(filterArray);
                setIsFilterselected(true);
                setModalIsOpen(false);
                localStorage.setItem("selectedFilter", JSON.stringify(selFilt));
                localStorage.setItem("pincode", pincode);
                js_cookie__WEBPACK_IMPORTED_MODULE_13__/* ["default"].set */ .Z.set("pincode", pincode, {
                    expires: 7
                });
            }).catch((error)=>console.log("error", error));
        }
    };
    const handlePinSave = ()=>{
        if (pincode.length == 6) {
            setModalIsOpen(false);
            localStorage.setItem("pincodeSkip", true);
            setLoading(true);
            (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_10__/* .savePincode */ .y1)({
                pincodedetails: pincode
            });
            js_cookie__WEBPACK_IMPORTED_MODULE_13__/* ["default"].set */ .Z.set("pincode", pincode, {
                expires: 7,
                secure: true,
                sameSite: "Strict"
            });
            localStorage.setItem("pincode", pincode);
            router.reload();
            return;
            setLoading(true);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var graphql = JSON.stringify({
                query: getPloaction,
                variables: {
                    pincode
                }
            });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: graphql,
                redirect: "follow"
            };
            fetch("https://proxy.orientbell.com", requestOptions).then((response)=>response.text()).then((result)=>{
                const finalResult = JSON.parse(result);
                const selFilt = {
                    key: finalResult.data.p_location.value,
                    value: finalResult.data.p_location.state,
                    code: finalResult.data.p_location.attribute_name
                };
                selectedFilters.push(selFilt);
                setSelectedFilters(selectedFilters);
                setIsFilterselected(true);
                setModalIsOpen(false);
                localStorage.setItem("selectedFilter", JSON.stringify(selFilt));
                localStorage.setItem("pincode", pincode);
            }).catch((error)=>console.log("error", error));
        } else {
            alert("Invalid Pin Code");
        }
    };
    const addProductToComapre = async (id)=>{
        if (localStorage.getItem("compareListUid")) {
            let addProduct = await (0,_api_services_js_catalouge__WEBPACK_IMPORTED_MODULE_7__/* .addItemInCompareList */ .AQ)({
                compareListUid: localStorage.getItem("compareListUid"),
                productIds: [
                    String(id)
                ]
            });
            if (addProduct === null || addProduct === void 0 ? void 0 : addProduct.message) {
                sweetalert__WEBPACK_IMPORTED_MODULE_8___default()(addProduct.message);
                return;
            }
            sweetalert__WEBPACK_IMPORTED_MODULE_8___default()({
                title: "Item added",
                text: "You have ".concat(addProduct.data.addProductsToCompareList.item_count, " in your compare list"),
                icon: "success",
                buttons: [
                    "Cancel",
                    "Compare"
                ]
            }).then((result)=>{
                if (result) {
                    router.push("/catalog/product_compare");
                }
            });
        } else {
            let createList = await (0,_api_services_js_catalouge__WEBPACK_IMPORTED_MODULE_7__/* .createCompareList */ .j9)({
                productIds: [
                    String(id)
                ]
            });
            if (createList.message) {
                sweetalert__WEBPACK_IMPORTED_MODULE_8___default()(createList.message);
            } else {
                localStorage.setItem("compareListUid", createList.data.createCompareList.uid);
                sweetalert__WEBPACK_IMPORTED_MODULE_8___default()("Iteam added in you compare list and more items to compare");
            }
        }
    };
    const submitGetInTouch = async ()=>{
        const namee = touch.name;
        const no = touch.number;
        const pin = touch.pincode;
        if (!namee || !no) {
            setTouch({
                ...touch,
                error: "All fields are required"
            });
        } else if (pin && String(pin).length != 6) {
            setTouch({
                ...touch,
                error: "Invalid Pincode"
            });
        } else {
            setTouch({
                ...touch,
                error: "",
                loading: true
            });
            let response = await (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_10__/* .getIntouch */ .JJ)({
                name: namee,
                phone: no,
                pincode: pin
            });
            if (response === null || response === void 0 ? void 0 : response.message) {
                localStorage.setItem("leadfilled", true);
                sweetalert__WEBPACK_IMPORTED_MODULE_8___default()(response === null || response === void 0 ? void 0 : response.message);
                setTouch({
                    ...touch,
                    error: "",
                    loading: false
                });
            } else {
                sweetalert__WEBPACK_IMPORTED_MODULE_8___default()(response.data.get_in_touch.msg);
                setGetInTouch(false);
                setTouch({
                    name: "",
                    number: "",
                    error: "",
                    loading: false
                });
            }
        }
    };
    const breadsCrumbSchema = (cat)=>{
        let arr = [
            {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.orientbell.com"
            }
        ];
        for(let i = 0; i < cat.breadcrumbs.length; i++){
            arr.push({
                "@type": "ListItem",
                position: i + 2,
                name: cat.breadcrumbs[i].category_name,
                item: "https://www.orientbell.com/".concat(cat.breadcrumbs[i].category_url_path)
            });
        }
        return {
            __html: JSON.stringify({
                "@context": "https://schema.org/",
                "@type": "BreadcrumbList",
                itemListElement: arr
            })
        };
    };
    const webPageSchema = ()=>{
        var ref, ref1, ref2, ref3, ref4;
        return {
            __html: '{\n        "@context": "https://schema.org",\n        "@type": "WebPage",\n        "url": "'.concat(router.asPath, '",\n        "headline": "",\n        "breadcrumb": "Home > Tiles > ').concat(((ref = dataSet.currentcategory) === null || ref === void 0 ? void 0 : ref.breadcrumbs) ? (ref2 = (ref1 = dataSet.currentcategory) === null || ref1 === void 0 ? void 0 : ref1.breadcrumbs[1]) === null || ref2 === void 0 ? void 0 : ref2.category_name : "", '",\n        "name": "').concat(dataSet === null || dataSet === void 0 ? void 0 : (ref3 = dataSet.currentcategory) === null || ref3 === void 0 ? void 0 : ref3.meta_title, '",\n        "description": "').concat(dataSet === null || dataSet === void 0 ? void 0 : (ref4 = dataSet.currentcategory) === null || ref4 === void 0 ? void 0 : ref4.meta_description, '"\n      }')
        };
    };
    let catName = router.asPath.split("/")[router.asPath.split("/").length - 1];
    const videoSchema = _videoSchema__WEBPACK_IMPORTED_MODULE_18___default()(catName);
    const handleRemoveUnbxdFilter = (filterToRemove)=>{
        setSelectedFilterFromUnbxd((prevFilters)=>{
            var ref;
            // Remove the selected filter from state
            const updatedFilters = prevFilters.filter((filter)=>!(filter.facetName === filterToRemove.facetName && filter.facetValue === filterToRemove.facetValue));
            // Update URL query params after removing the filter
            const urlObj = new URL(window.location.href);
            // Get the transformed filter name and value
            const { transformedName , transformedValue  } = transformFilter(filterToRemove.facetName, filterToRemove.facetValue);
            // Remove only the matching query parameter from URL
            urlObj.searchParams.delete(transformedName);
            // Update browser history without reloading
            window.history.pushState({}, "", urlObj.toString());
            // Construct the new Unbxd API URL
            const unbxdUrl = new URL("https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category?p-id=categoryPathId%3A%22".concat(encodeURIComponent((ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("?")[0]), "%22"));
            // Add fixed parameters
            unbxdUrl.searchParams.append("facet.multiselect", "true");
            unbxdUrl.searchParams.append("spellcheck", "true");
            unbxdUrl.searchParams.append("pagetype", "boolean");
            unbxdUrl.searchParams.append("start", "0");
            unbxdUrl.searchParams.append("rows", "".concat(pageSizeUnbxd + 25));
            unbxdUrl.searchParams.append("version", "V2");
            unbxdUrl.searchParams.append("fallback", "true");
            unbxdUrl.searchParams.append("viewType", "GRID");
            unbxdUrl.searchParams.append("facet.version", "V2");
            // Apply remaining filters to API request
            updatedFilters.forEach((param)=>{
                let { facetName , facetValue  } = param;
                unbxdUrl.searchParams.append("filter", "".concat(facetName, ':"').concat(facetValue, '"'));
            });
            // Make the API call
            (async ()=>{
                try {
                    const response = await axios__WEBPACK_IMPORTED_MODULE_21__/* ["default"].get */ .Z.get(unbxdUrl.toString(), {
                        headers: {
                            "unbxd-user-id": js_cookie__WEBPACK_IMPORTED_MODULE_13__/* ["default"].get */ .Z.get("unbxd.userId")
                        }
                    });
                    // Update state with the response
                    setUnbxdPdts(response.data.response.products);
                    setNoOfFilteredPdtFromUnbxd(response.data.response.numberOfProducts);
                } catch (error) {
                    console.log(error);
                    sweetalert__WEBPACK_IMPORTED_MODULE_8___default()("Something went wrong while removing the filter, please try again.");
                }
            })();
            return updatedFilters;
        });
    };
    const removeUnbxdFilters = async ()=>{
        var ref;
        // Clear all filters from state
        setSelectedFilterFromUnbxd([]);
        // Remove all filters from URL
        const urlObj = new URL(window.location.href);
        urlObj.search = ""; // Clears query params
        window.history.pushState({}, "", urlObj.toString());
        // Construct API URL without filters
        const unbxdUrl = new URL("https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category?p-id=categoryPathId%3A%22".concat(encodeURIComponent((ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("?")[0]), "%22"));
        // Add fixed parameters
        unbxdUrl.searchParams.append("facet.multiselect", "true");
        unbxdUrl.searchParams.append("spellcheck", "true");
        unbxdUrl.searchParams.append("pagetype", "boolean");
        unbxdUrl.searchParams.append("start", "0");
        unbxdUrl.searchParams.append("rows", "25");
        unbxdUrl.searchParams.append("version", "V2");
        unbxdUrl.searchParams.append("fallback", "true");
        unbxdUrl.searchParams.append("viewType", "GRID");
        unbxdUrl.searchParams.append("facet.version", "V2");
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_21__/* ["default"].get */ .Z.get(unbxdUrl.toString(), {
                headers: {
                    "unbxd-user-id": js_cookie__WEBPACK_IMPORTED_MODULE_13__/* ["default"].get */ .Z.get("unbxd.userId")
                }
            });
            // Update state with unfiltered results
            setUnbxdPdts(response.data.response.products);
            setNoOfFilteredPdtFromUnbxd(response.data.response.numberOfProducts);
        } catch (error) {
            console.log(error);
            sweetalert__WEBPACK_IMPORTED_MODULE_8___default()("Something went wrong while removing filters, please try again.");
        }
    };
    const transformFilter = (facetName, facetValue)=>{
        var ref;
        // Get the transformed filter name
        const filterMapping = filterMapArr[0]; // Extracting from the array
        const transformedName = filterMapping[facetName] || facetName; // Default to original if no mapping
        // Get the transformed value
        const valueMapping = ((ref = _attributes_json__WEBPACK_IMPORTED_MODULE_19__[transformedName]) === null || ref === void 0 ? void 0 : ref.options) || {}; // Fetch value mapping from JSON
        const transformedValue = Object.keys(valueMapping).find((key)=>valueMapping[key] === facetValue) || facetValue; // Default to original if no match
        return {
            transformedName,
            transformedValue
        };
    };
    const filterResultsWithFacets = async (facetName, facetValue)=>{
        setSelectedFilterFromUnbxd((prevFilters)=>{
            const existingFilter = prevFilters.filter((filter)=>filter.facetName === facetName);
            let updatedFilters;
            if (existingFilter.length > 0) {
                updatedFilters = [
                    ...prevFilters.filter((filter)=>filter.facetName !== facetName),
                    {
                        facetName,
                        facetValue
                    }
                ];
            } else {
                updatedFilters = [
                    ...prevFilters,
                    {
                        facetName,
                        facetValue
                    }
                ];
            }
            setmobileFilterOpen(false);
            console.log("es ", updatedFilters);
            // Update URL query params
            const urlObj = new URL(window.location.href);
            updatedFilters.forEach((param)=>{
                let { facetName , facetValue  } = param;
                const { transformedName , transformedValue  } = transformFilter(facetName, facetValue);
                urlObj.searchParams.set(transformedName, transformedValue);
            });
            // Push updated URL without reloading
            window.history.pushState({}, "", urlObj.toString());
            // Unbxd API URL setup
            const unbxdUrl = new URL("https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category?p-id=categoryPathId%3A%22".concat(encodeURIComponent(router.asPath.split("?")[0]), "%22"));
            // Add query parameters
            unbxdUrl.searchParams.append("facet.multiselect", "true");
            unbxdUrl.searchParams.append("spellcheck", "true");
            unbxdUrl.searchParams.append("pagetype", "boolean");
            unbxdUrl.searchParams.append("start", "0");
            unbxdUrl.searchParams.append("rows", "".concat(pageSizeUnbxd + 25));
            unbxdUrl.searchParams.append("version", "V2");
            unbxdUrl.searchParams.append("fallback", "true");
            unbxdUrl.searchParams.append("viewType", "GRID");
            unbxdUrl.searchParams.append("facet.version", "V2");
            // Apply transformed filters to API request
            updatedFilters.forEach((param)=>{
                let { facetName , facetValue  } = param;
                const { transformedName , transformedValue  } = transformFilter(facetName, facetValue);
                unbxdUrl.searchParams.append("filter", "".concat(facetName, ':"').concat(facetValue, '"'));
            });
            // Make the API call
            (async ()=>{
                try {
                    const response = await axios__WEBPACK_IMPORTED_MODULE_21__/* ["default"].get */ .Z.get(unbxdUrl.toString(), {
                        headers: {
                            "unbxd-user-id": js_cookie__WEBPACK_IMPORTED_MODULE_13__/* ["default"].get */ .Z.get("unbxd.userId")
                        }
                    });
                    // Update state with the response
                    setUnbxdPdts(response.data.response.products);
                    setNoOfFilteredPdtFromUnbxd(response.data.response.numberOfProducts);
                    setPageSalesSize(response.data.response.products.length);
                } catch (error) {
                    console.log(error);
                // swal("Something went wrong, please try again later.");
                }
            })();
            return updatedFilters;
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        if (((ref = data.appliedFilterFromUnbxd) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            const validFilters = [];
            data.appliedFilterFromUnbxd.forEach((filter)=>{
                var ref;
                const [key, value] = Object.entries(filter)[0];
                // Find Unbxd key for this key
                const unbxdKey = Object.keys(filterMapArr[0]).find((unbxdKey)=>filterMapArr[0][unbxdKey] === key);
                // Find mapped display value for the filter
                const facetValue = (ref = _attributes_json__WEBPACK_IMPORTED_MODULE_19__[key]) === null || ref === void 0 ? void 0 : ref.options[value];
                if (unbxdKey && facetValue) {
                    validFilters.push({
                        facetName: unbxdKey,
                        facetValue,
                        originalKey: key,
                        originalValue: value
                    });
                } else {
                    console.warn("Skipping invalid filter:", {
                        key,
                        value,
                        unbxdKey,
                        facetValue
                    });
                }
            });
            setSelectedFilterFromUnbxd(validFilters.map((param)=>{
                let { facetName , facetValue  } = param;
                return {
                    facetName,
                    facetValue
                };
            }));
            // Build Unbxd URL
            const unbxdUrl = new URL("https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category?p-id=categoryPathId%3A%22".concat(encodeURIComponent(router.asPath.split("?")[0]), "%22"));
            unbxdUrl.searchParams.append("facet.multiselect", "true");
            unbxdUrl.searchParams.append("spellcheck", "true");
            unbxdUrl.searchParams.append("pagetype", "boolean");
            unbxdUrl.searchParams.append("start", "0");
            unbxdUrl.searchParams.append("rows", "25");
            unbxdUrl.searchParams.append("version", "V2");
            unbxdUrl.searchParams.append("fallback", "true");
            unbxdUrl.searchParams.append("viewType", "GRID");
            unbxdUrl.searchParams.append("facet.version", "V2");
            // Add filters to URL
            validFilters.forEach((param)=>{
                let { facetName , facetValue  } = param;
                unbxdUrl.searchParams.append("filter", "".concat(facetName, ':"').concat(facetValue, '"'));
            });
            // Make API call
            (async ()=>{
                try {
                    const response = await axios__WEBPACK_IMPORTED_MODULE_21__/* ["default"].get */ .Z.get(unbxdUrl.toString(), {
                        headers: {
                            "unbxd-user-id": js_cookie__WEBPACK_IMPORTED_MODULE_13__/* ["default"].get */ .Z.get("unbxd.userId")
                        }
                    });
                    setUnbxdPdts(response.data.response.products);
                    setNoOfFilteredPdtFromUnbxd(response.data.response.numberOfProducts);
                    setPageSalesSize(response.data.response.products.length);
                } catch (error) {
                    console.error("Error fetching Unbxd products:", error);
                }
            })();
            // Clean up URL if some filters were invalid
            if (validFilters.length !== data.appliedFilterFromUnbxd.length) {
                const queryObj = {};
                validFilters.forEach((param)=>{
                    let { originalKey , originalValue  } = param;
                    queryObj[originalKey] = originalValue;
                });
                router.replace({
                    pathname: router.pathname,
                    query: {
                        ...queryObj,
                        category: router.query.category
                    }
                }, undefined, {
                    shallow: true
                });
            }
        } else {
            let unbxdUrl1 = "https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category?p-id=categoryPathId%3A%22".concat(encodeURIComponent(router.asPath.split("?")[0]), "%22&facet.multiselect=true&spellcheck=true&pagetype=boolean&rows=25&start=0&version=V2&fallback=true&viewType=GRID&facet.version=V2");
            (async ()=>{
                try {
                    const response = await axios__WEBPACK_IMPORTED_MODULE_21__/* ["default"].get */ .Z.get(unbxdUrl1, {
                        headers: {
                            "unbxd-user-id": js_cookie__WEBPACK_IMPORTED_MODULE_13__/* ["default"].get */ .Z.get("unbxd.userId")
                        }
                    });
                    // ✅ Update state here
                    setUnbxdPdts(response.data.response.products);
                    setNoOfFilteredPdtFromUnbxd(response.data.response.numberOfProducts);
                    setPageSalesSize(response.data.response.products.length);
                } catch (error) {
                    console.error("Error fetching Unbxd products:", error);
                    sweetalert__WEBPACK_IMPORTED_MODULE_8___default()("Something went wrong, please try again later.");
                }
            })();
        }
    }, [
        data.appliedFilterFromUnbxd
    ]);
    const handleClick = ()=>{
        const cleanPath = window.location.pathname.split("?")[0]; // Remove query parameters
        router.replace(cleanPath, undefined, {
            shallow: true
        }); // Update URL without full reload
        setTimeout(()=>{
            handleRemove2(cleanPath); // Pass the cleaned URL
        }, 100); // Delay ensures URL updates before navigating
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_5___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charset: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        content: dataSet.currentcategory.meta_title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: dataSet.currentcategory.meta_title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: dataSet.currentcategory.meta_description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: dataSet.currentcategory.meta_keywords
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "format-detection",
                        content: "telephone=no"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "preconnect dns-prefetch",
                        href: "https://connect.facebook.net",
                        crossorigin: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "preconnect dns-prefetch",
                        href: "https://www.googletagmanager.com",
                        crossorigin: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        "http-equiv": "Accept-CH",
                        content: "viewport-width, width, device-memory, dpr, downlink, ect"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "pinterest-rich-pin",
                        content: "false"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: dataSet.currentcategory.meta_description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: dataSet.currentcategory.meta_title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "".concat(_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].API_ENDPOINT */ .Z.API_ENDPOINT, "/media/img/logo.png")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "Orientbell"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "Orientbell"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "".concat(_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/").concat(router.query.category ? router.query.category.join("/") : "/tiles")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: dataSet.currentcategory.meta_description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: dataSet.currentcategory.meta_title
                    }),
                    (dataSet === null || dataSet === void 0 ? void 0 : (ref8 = dataSet.currentcategory) === null || ref8 === void 0 ? void 0 : ref8.schema) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: dataSet.currentcategory.schema.split(/<script[^>]*>/g) // Split by opening <script> tags
                        .filter((schema)=>schema.trim()) // Filter out any empty strings
                        .map((schemaContent, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                                type: "application/ld+json",
                                dangerouslySetInnerHTML: {
                                    __html: schemaContent.replace(/<\/script>/g, "")
                                }
                            }, index))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "".concat(_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].API_ENDPOINT */ .Z.API_ENDPOINT, "/media/img/logo.png")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "text/javascript",
                        src: "https://cdn.roomvo.com/static/scripts/b2b/orientbell.js",
                        defer: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: webPageSchema()
                    }),
                    Object.keys(videoSchema).length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: videoSchema
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: breadsCrumbSchema(dataSet.currentcategory)
                    }),
                    pinFromCityPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "page-wrapper category_listing_page",
                children: [
                    !data.PinFromCityPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: stickyTop ? "select-location-wrapper " : "select-location-wrapper stick-top",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "TO FIND PRICES IN YOUR CITY, ENTER YOUR PINCODE"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "select-wraper",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    value: pincode,
                                    onChange: (e)=>handlePinCodeChangeInput(e)
                                })
                            })
                        ]
                    }),
                    (pincode === null || pincode === void 0 ? void 0 : pincode.length) == 0 || pincode == undefined || (pincode === null || pincode === void 0 ? void 0 : pincode.length) !== 6 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: " Invalid PinCode"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                        className: "category-section",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "category-view",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "filter-by-mobile flex-class",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "locaton-custom",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        class: "foot-icon-bx",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "/Sort-By.svg",
                                                            alt: "Sort"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                                        className: "form-control",
                                                        id: "sel1",
                                                        value: sortValue,
                                                        onChange: (e)=>handleSortChange(e),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                value: "",
                                                                children: "Sort By"
                                                            }),
                                                            dataSet.sort_fields.options.map((obj)=>{
                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                    value: obj.value,
                                                                    children: obj.label
                                                                }, obj.value);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "filter-col",
                                                onClick: ()=>setmobileFilterOpen(!mobileFilterOpen),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        class: "foot-icon-bx",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "/filter.svg",
                                                            alt: "Orientbell Tiles Filter"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "sort-filter-col",
                                                        children: "Filter by"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: mobileFilterOpen ? "main-sidebar open-filter" : "main-sidebar",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "filter-heading-head",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                        children: "FILTERS"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "filter-close-bx",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "/close-img.webp",
                                                            alt: "close",
                                                            onClick: ()=>setmobileFilterOpen(false)
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "filter-overlay-bx",
                                                onClick: ()=>setmobileFilterOpen(false)
                                            }),
                                            (ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : ProdBySalesDate.proCount) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "pro-filter-row",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                    className: "add_cls nopin",
                                                    children: filterTypeDataSet === null || filterTypeDataSet === void 0 ? void 0 : filterTypeDataSet.map((val, index)=>{
                                                        var ref, ref1;
                                                        const imageName = "/".concat(val.toLowerCase(), ".png");
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            className: filteractive === index ? "filter-active-cls" : "filter-inactive-cat",
                                                            onClick: ()=>{
                                                                onFilterOnClickButton(val.toString());
                                                                setFilterActive(index);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "flt-type-img",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: imageName,
                                                                        alt: ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h6", {
                                                                    children: [
                                                                        val == "Floor" ? "Wall/Floor" : val,
                                                                        " "
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "filters-by open-filter",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                        className: selectedCode == "colors" ? "color-row" : "",
                                                                        children: selectedCode == "tile_factory_production" && ((ref = data.regionData) === null || ref === void 0 ? void 0 : ref.state) ? (ref1 = selectedFilterData.filter((cc)=>{
                                                                            var ref, ref1;
                                                                            return (ref1 = StatePlant[(ref = data.regionData) === null || ref === void 0 ? void 0 : ref.state]) === null || ref1 === void 0 ? void 0 : ref1.includes(cc.value);
                                                                        })) === null || ref1 === void 0 ? void 0 : ref1.map((obj, index)=>{
                                                                            if (router.query[selectedCode] == obj.key) {
                                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                                    children: [
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                            style: {
                                                                                                background: "#939393",
                                                                                                color: "white"
                                                                                            },
                                                                                            className: selectedCode == "colors" ? obj.value : "",
                                                                                            children: obj.value
                                                                                        }, index)
                                                                                    ]
                                                                                });
                                                                            } else {
                                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                        onClick: ()=>{
                                                                                            onFilterClick(obj.key, obj.value);
                                                                                        },
                                                                                        children: obj.value
                                                                                    }, index)
                                                                                });
                                                                            }
                                                                        }) : selectedFilterData === null || selectedFilterData === void 0 ? void 0 : selectedFilterData.map((obj, index)=>{
                                                                            if (router.query[selectedCode] == obj.key) {
                                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                                    children: [
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                            style: {
                                                                                                background: "#939393",
                                                                                                color: "white"
                                                                                            },
                                                                                            className: selectedCode == "colors" ? obj.value : "",
                                                                                            children: [
                                                                                                selectedCode == "colors" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("spna", {
                                                                                                    className: "color-option"
                                                                                                }),
                                                                                                obj.value
                                                                                            ]
                                                                                        }, index),
                                                                                        index == 4 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                            className: "popular-sparater"
                                                                                        })
                                                                                    ]
                                                                                });
                                                                            } else {
                                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                                            className: selectedCode == "colors" ? obj.value : "",
                                                                                            onClick: ()=>{
                                                                                                onFilterClick(obj.key, obj.value);
                                                                                            },
                                                                                            children: [
                                                                                                selectedCode == "colors" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("spna", {
                                                                                                    className: "color-option"
                                                                                                }),
                                                                                                obj.value
                                                                                            ]
                                                                                        }, index),
                                                                                        index == 4 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                            className: "popular-sparater"
                                                                                        })
                                                                                    ]
                                                                                });
                                                                            }
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }, index);
                                                    })
                                                })
                                            }) : Array.isArray(data === null || data === void 0 ? void 0 : (ref9 = data.facetsUnbxd) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.text) === null || ref10 === void 0 ? void 0 : ref10.list) && (data === null || data === void 0 ? void 0 : (ref11 = data.facetsUnbxd) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.text) === null || ref12 === void 0 ? void 0 : ref12.list.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "pro-filter-row",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                    className: "add_cls tt",
                                                    children: (data === null || data === void 0 ? void 0 : (ref13 = data.facetsUnbxd) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.text) === null || ref14 === void 0 ? void 0 : ref14.list.length) > 1 && (data === null || data === void 0 ? void 0 : (ref15 = data.facetsUnbxd) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.text) === null || ref16 === void 0 ? void 0 : ref16.list.map((facet, facetIndex)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            className: filteractive === facetIndex ? "filter-active-cls" : "filter-inactive-cat",
                                                            onClick: ()=>{
                                                                setFilterActive(facetIndex);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "flt-type-img",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "/floor.png",
                                                                        alt: ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                                    children: facet.displayName
                                                                }),
                                                                filteractive === facetIndex && // Render values only for the active facet
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "filters-by open-filter",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                        children: facet.values.filter((_, index)=>index % 2 === 0) // Extract keys only (names)
                                                                        .map((value, valueIndex)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                onClick: ()=>filterResultsWithFacets(facet.filterField, value),
                                                                                style: selectedFilterFromUnbxd.filter((i)=>i.facetValue === value).length > 0 ? {
                                                                                    background: "#939393",
                                                                                    color: "white"
                                                                                } : {},
                                                                                children: value
                                                                            }, valueIndex))
                                                                    })
                                                                })
                                                            ]
                                                        }, facetIndex)))
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "product-listing-wrap",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "bread-crumb-row",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: _config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL,
                                                                children: "Home"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "/tiles",
                                                                children: "Tiles"
                                                            })
                                                        }),
                                                        dataSet.currentcategory.breadcrumbs && dataSet.currentcategory.breadcrumbs.map((bre, inddd)=>{
                                                            if (inddd != 0 && bre.category_name != "All Tiles") {
                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: "".concat(_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/").concat(bre.category_url_path),
                                                                        children: bre.category_name
                                                                    })
                                                                }, inddd);
                                                            }
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                children: dataSet.currentcategory.name
                                            }),
                                            dataSet.currentcategory.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "category_accordion_data desktop",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: dataSet.currentcategory.description.replace(/<p>\s*<\/p>/g, "")
                                                    }
                                                })
                                            }),
                                            dataSet.currentcategory.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "category_accordion_data mobile",
                                                children: isExpanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: dataSet.currentcategory.description.replace(/<p>\s*<\/p>/g, "")
                                                    }
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: shortDescription
                                                            }
                                                        }),
                                                        shortDescription.replace(/<p>\s*<\/p>/g, "").trim() !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                            className: "read-btn-cat-page-grey",
                                                            onClick: toggleExpand,
                                                            children: "Read More"
                                                        })
                                                    ]
                                                })
                                            }),
                                            (ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : ProdBySalesDate.proCount) >= 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "amshopby-filter",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        selectedFilters.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                            className: "clear-all-btn",
                                                            onClick: ()=>removeAllFilters(),
                                                            children: "Clear All Filters X"
                                                        }),
                                                        data.data.products.appliedFilters.filter((cuu)=>{
                                                            return (cuu === null || cuu === void 0 ? void 0 : cuu.attribute_code) != "plocation";
                                                        }).map((obj, index)=>{
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                children: [
                                                                    obj.label,
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        onClick: ()=>handleRemove(obj),
                                                                        children: "X"
                                                                    })
                                                                ]
                                                            }, index);
                                                        }),
                                                        data.regionData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                data.regionData.state,
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                    onClick: ()=>handleClick(),
                                                                    children: "X"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "amshopby-filter",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        selectedFilterFromUnbxd.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                            className: "clear-all-btn",
                                                            onClick: ()=>removeUnbxdFilters(),
                                                            children: "Clear All Filters X"
                                                        }),
                                                        selectedFilterFromUnbxd.map((filter, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                children: [
                                                                    filter.facetValue,
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        onClick: ()=>handleRemoveUnbxdFilter(filter),
                                                                        children: "X"
                                                                    })
                                                                ]
                                                            }, index))
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "category-sorting",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "tilecountis-bx",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        onClick: ()=>{
                                                                            handleLayOutclass("one");
                                                                        },
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                            className: "fa fa-th"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        onClick: ()=>{
                                                                            handleLayOutclass("two");
                                                                        },
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                            className: "fa fa-th-large"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        onClick: ()=>{
                                                                            handleLayOutclass("three");
                                                                        },
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                            className: "fa fa-bars"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        (ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : ProdBySalesDate.proCount) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            children: [
                                                                "Items 1-",
                                                                ProdBySalesDate.data.length,
                                                                " of",
                                                                " ",
                                                                ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : ProdBySalesDate.proCount
                                                            ]
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "xxx",
                                                            children: (UnbxdPdts === null || UnbxdPdts === void 0 ? void 0 : UnbxdPdts.length) > 0 ? "Items 1-".concat(UnbxdPdts.length < data.UnbxdResponse.numberOfProducts ? UnbxdPdts.length : data.UnbxdResponse.numberOfProducts, " of ").concat(noOfFilteredPdtFromUnbxd || data.UnbxdResponse.numberOfProducts) : "Items 0 of 0"
                                                        })
                                                    ]
                                                })
                                            }),
                                            firstLoading ? //         <Confetti
                                            //         numberOfPieces={300}
                                            //         tweenDuration={10}
                                            //         width={width}
                                            //         height={height}
                                            //   colors={['#009444', '#ffca34']}
                                            // style={{
                                            //    zIndex: 9999,
                                            //    position: 'fixed',
                                            //    top: 0,
                                            //    left: 0,
                                            //    width: '100vw',
                                            //    height: '100vh',
                                            //  }}
                                            // />
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fireworks_js_react__WEBPACK_IMPORTED_MODULE_17__/* .Fireworks */ .j, {
                                                options: {
                                                    rocketsPoint: {
                                                        min: 0,
                                                        max: 100
                                                    }
                                                },
                                                style: {
                                                    top: 0,
                                                    left: 0,
                                                    width: "100%",
                                                    height: "100%",
                                                    position: "fixed"
                                                }
                                            }) : loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_loader__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: pageLayoutClass,
                                                    children: (ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : (ref17 = ProdBySalesDate.data) === null || ref17 === void 0 ? void 0 : ref17.length) > 0 ? ProdBySalesDate.data.map((product, index)=>{
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                            children: [
                                                                (index == 3 || index == 27 || index == 51) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-listing-col",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "/catagoryLeadImg.jpeg",
                                                                        alt: "Tile Expert Assistance Banner",
                                                                        onClick: ()=>setGetInTouch(true),
                                                                        className: "categoryBanner"
                                                                    })
                                                                }),
                                                                (index == 11 || index == 35 || index == 59) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-listing-col",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "/OBL.jpg",
                                                                        onClick: ()=>setGetInTouch(true),
                                                                        alt: "image",
                                                                        className: "categoryBanner"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_productCard__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                                    isAmbience: isAmbience,
                                                                    product: product,
                                                                    category: dataSet.currentcategory.name,
                                                                    addProductToComapre: addProductToComapre,
                                                                    pinFromCityPage: pinFromCityPage
                                                                })
                                                            ]
                                                        });
                                                    }) : UnbxdPdts === null || UnbxdPdts === void 0 ? void 0 : UnbxdPdts.map((product, index)=>{
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                            children: [
                                                                (index == 3 || index == 27 || index == 51) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-listing-col",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "/catagoryLeadImg.jpeg",
                                                                        onClick: ()=>setGetInTouch(true),
                                                                        className: "categoryBanner"
                                                                    })
                                                                }),
                                                                (index == 11 || index == 35 || index == 59) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-listing-col",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "/OBL.jpg",
                                                                        onClick: ()=>setGetInTouch(true),
                                                                        alt: "image",
                                                                        className: "categoryBanner"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_UnbxdProductCard__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                                    isAmbience: isAmbience,
                                                                    product: product,
                                                                    category: dataSet.currentcategory.name,
                                                                    addProductToComapre: addProductToComapre
                                                                })
                                                            ]
                                                        });
                                                    })
                                                })
                                            }),
                                            loading2 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_loader__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "load-more-product",
                                                children: (ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : ProdBySalesDate.proCount) > 0 && (ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : ProdBySalesDate.proCount) != ProdBySalesDate.data.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                    onClick: ()=>{
                                                        loadMoreSalesData(pinFromCityPage ? pinFromCityPage : js_cookie__WEBPACK_IMPORTED_MODULE_13__/* ["default"].get */ .Z.get("pincode"));
                                                    },
                                                    children: [
                                                        "Load More From ",
                                                        (ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : ProdBySalesDate.proCount) - PageSalesSize
                                                    ]
                                                }) : (ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : ProdBySalesDate.length) === 0 && UnbxdPdts.length > 0 && UnbxdPdts.length < (noOfFilteredPdtFromUnbxd || data.UnbxdResponse.numberOfProducts) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                    className: "bt",
                                                    onClick: ()=>{
                                                        pageSizeUnbxd += 25;
                                                        loadMoreSalesData2(); // Make sure this function updates noOfFilteredPdtFromUnbxd correctly
                                                        // After loading all products, update the total count to prevent incorrect numbers
                                                        if (UnbxdPdts.length === noOfFilteredPdtFromUnbxd) {
                                                            noOfFilteredPdtFromUnbxd = UnbxdPdts.length;
                                                        }
                                                    },
                                                    children: "Load More"
                                                })
                                            }),
                                            stores.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "category-store-section-row",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                                        children: [
                                                            "Orientbell Tiles Dealers in ",
                                                            cityName,
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "store_locator_row",
                                                        children: stores.slice(0, visibleCount).map((store, index)=>{
                                                            let mob1 = store.d_phone_no.split("/")[0];
                                                            let mob2 = store.d_phone_no.split("/")[1];
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "obl_store_locator_col",
                                                                children: [
                                                                    store.d_customer_type === "OBTB" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "store_obl_logo",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                            src: "/store_obl_logo_icon.svg",
                                                                            alt: "OBTB"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                        children: store.d_name.replace("&amp;", "&")
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "store_add_row",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "store_add_text",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                                                    children: store.d_address
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                                    children: [
                                                                                        store.d_city,
                                                                                        ", ",
                                                                                        store.d_state
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            });
                                                        })
                                                    }),
                                                    visibleCount < stores.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "tru_btn_new",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                            className: "btn btn-primary",
                                                            onClick: showMoreStores,
                                                            children: "Show More Stores"
                                                        })
                                                    }) : stores.length > 12 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "tru_btn_new",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                            className: "btn btn-primary",
                                                            onClick: showLessStores,
                                                            children: "Show Less Stores"
                                                        })
                                                    })
                                                ]
                                            }),
                                            (selectedFilterFromUnbxd === null || selectedFilterFromUnbxd === void 0 ? void 0 : selectedFilterFromUnbxd.length) > 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "category_accordion_data"
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "category_accordion_data",
                                                dangerouslySetInnerHTML: {
                                                    __html: dataSet.currentcategory.dynamic_content.replace(/<p>\s*(&nbsp;)?\s*<\/p>/g, "")
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "tru_btn_new",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: "btn btn-primary",
                                                    href: "/trialook",
                                                    children: "Trialook"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "tile-related-blog-section",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "container",
                                    children: (relatedBlogData === null || relatedBlogData === void 0 ? void 0 : relatedBlogData.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "tile-related-blog",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "title",
                                                children: "Related Blogs"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "listing-Wrap",
                                                children: relatedBlogData === null || relatedBlogData === void 0 ? void 0 : relatedBlogData.map((obj, index)=>{
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "listing-col",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "listingImg",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: obj.permalink,
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: obj.image,
                                                                        loading: "lazy",
                                                                        alt: "Marble Tiles Vs Marble Slab: What is Better for Your Home?"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "listing_blog_data",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "listingDate",
                                                                        children: obj.date
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "listingHead",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: obj.permalink,
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                dangerouslySetInnerHTML: {
                                                                                    __html: obj.title
                                                                                }
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "listingText",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                        children: [
                                                                            " ",
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                dangerouslySetInnerHTML: {
                                                                                    __html: obj.content.slice(0, -11)
                                                                                }
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "listingButton",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: obj.permalink,
                                                                            children: "Read More"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "modal show pincode-popup-bx",
                style: {
                    display: "block",
                    position: "initial"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                        show: modalIsOpen,
                        className: "pincode-popup-bx",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Dialog */ .Z.Dialog, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Header */ .Z.Header, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Title */ .Z.Title, {
                                        children: "Enter your Pincode for best prices"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Body */ .Z.Body, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                            value: pincode,
                                            onChange: (e)=>handlePinCodeChange(e)
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Footer */ .Z.Footer, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                            variant: "primary",
                                            onClick: ()=>handlePinSave(),
                                            children: "Submit"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                            variant: "secondary",
                                            onClick: ()=>{
                                                setModalIsOpen(false);
                                                localStorage.setItem("pincodeSkip", true);
                                            },
                                            children: "Don't show again"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                        show: getInTouch,
                        className: "pincode-popup-bx expert_assistance_modal",
                        onHide: ()=>setGetInTouch(false),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Dialog */ .Z.Dialog, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Header */ .Z.Header, {
                                    closeButton: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Title */ .Z.Title, {
                                        children: "Get Tile Expert Assistance"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_22__/* ["default"].Body */ .Z.Body, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                        onSubmit: (e)=>{
                                            e.preventDefault();
                                            submitGetInTouch();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_24__/* ["default"].Group */ .Z.Group, {
                                                className: "mb-3",
                                                controlId: "formBasicEmail",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_24__/* ["default"].Label */ .Z.Label, {
                                                        children: "Name"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_24__/* ["default"].Control */ .Z.Control, {
                                                        type: "text",
                                                        placeholder: "Name*",
                                                        onChange: (e)=>{
                                                            setTouch({
                                                                ...touch,
                                                                name: e.target.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_24__/* ["default"].Group */ .Z.Group, {
                                                className: "mb-3",
                                                controlId: "formBasicPassword",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_24__/* ["default"].Label */ .Z.Label, {
                                                        children: "Mobile"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_24__/* ["default"].Control */ .Z.Control, {
                                                        type: "number",
                                                        placeholder: "Mobile Number*",
                                                        onChange: (e)=>{
                                                            setTouch({
                                                                ...touch,
                                                                number: e.target.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_24__/* ["default"].Group */ .Z.Group, {
                                                className: "mb-3",
                                                controlId: "formBasicPassword",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_24__/* ["default"].Label */ .Z.Label, {
                                                        children: "Pincode (Optional)"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_24__/* ["default"].Control */ .Z.Control, {
                                                        type: "number",
                                                        placeholder: "Pincode (Optional)",
                                                        onChange: (e)=>{
                                                            setTouch({
                                                                ...touch,
                                                                pincode: e.target.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            }),
                                            touch.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "error text-danger",
                                                children: touch.error
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                                variant: "primary",
                                                type: "submit",
                                                disabled: touch.loading,
                                                style: {
                                                    width: "100%"
                                                },
                                                children: touch.loading ? "Submitting" : "Submit"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Category);


/***/ }),

/***/ 94793:
/***/ (function(module) {

"use strict";

const generateVideoSchema = (tileType)=>{
    // Define video details for each tile type
    const videoData = {
        "wall-tiles": {
            videoLink: "https://www.youtube.com/watch?v=zQLDurlHrNw",
            name: "How to Install Wall Tiles - Step-by-Step Guide",
            description: "Discover the expert step-by-step process for installing wall tiles in this detailed guide. Learn how to improve the aesthetic appeal and durability of your walls with trending tiles.",
            thumbnailUrl: "https://img.youtube.com/vi/zQLDurlHrNw/maxresdefault.jpg",
            uploadDate: "2021-04-26T07:15:44Z",
            duration: "PT14M27S",
            interactionCount: 9863
        },
        "bathroom-tiles": {
            videoLink: "https://www.youtube.com/watch?v=zomjakM68Rs",
            name: "Guide to Choosing the Best Bathroom Tiles",
            description: "Explore the art of selecting the perfect bathroom tiles to create a serene and functional space. Discover various sizes, colors, and designs to suit your dream bathroom. Watch now to learn tips for selecting the right bathroom tiles for walls and floors!",
            thumbnailUrl: "https://i.ytimg.com/vi/zomjakM68Rs/default.jpg",
            uploadDate: "2021-01-19T12:17:44Z",
            duration: "PT2M9S",
            interactionCount: 45195
        }
    };
    // Check for valid tileType
    const videoDetails = videoData[tileType];
    if (!videoDetails) {
        return JSON.stringify({});
    }
    // Construct schema
    const pageUrl = "https://www.orientbell.com/tiles/".concat(tileType);
    const schema = {
        "@context": "https://schema.org",
        "@type": "VideoObject",
        "name": videoDetails.name,
        "description": videoDetails.description,
        "thumbnailUrl": videoDetails.thumbnailUrl,
        "uploadDate": videoDetails.uploadDate,
        "duration": videoDetails.duration,
        "contentUrl": pageUrl,
        "embedUrl": "https://www.youtube.com/embed/".concat(videoDetails.videoLink.split("v=")[1]),
        "publisher": {
            "@type": "Organization",
            "name": "Orientbell Tiles",
            "logo": {
                "@type": "ImageObject",
                "url": "https://server.orientbell.com/media/img/logo-white.png"
            }
        },
        "author": {
            "@type": "Person",
            "name": "Orientbell Tiles"
        },
        "interactionStatistic": {
            "@type": "InteractionCounter",
            "interactionType": "https://schema.org/WatchAction",
            "userInteractionCount": videoDetails.interactionCount
        }
    };
    return JSON.stringify(schema);
};
module.exports = generateVideoSchema;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7361,5518,4585,7615,6212,5063,6737,7528,7007,9726,3372,7349,166,9774,2888,179], function() { return __webpack_exec__(66452); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);